import $ from 'jquery';

(() => {

  const hoge = '_GlobalMenu';
  // console.log(hoge);

  //menu open
  var scrollPos;
  $('#js-menu').on('click',function(e){
    $(this).toggleClass('open');
    $('.ot__menu').toggleClass('open');
    $('body').removeClass('open');
    



  })

  //menu click
  $('.ot__menu--listItem a').on('click',function(e){
    $('.ot__menu').removeClass('open');
    $('#js-menu').removeClass('open');
    $('body').removeClass('open');
  })







})();
